import "./event.css";

export default function Events() {
    return(
        <div className="container">
            <div className="events">
                <div className="container-fluid events">
                    <div className="row">
                        <div className="col-md-12 events">

                            <div className="item-list">
                                <ul className="ji-item-list">
                                    <li className="post event">
                                        <a className="body" href="https://www.redhat.com/en/events/webinar/transforming-test-driven-workflows-into-ci/cd-pipelines-with-jenkins" rel="noreferrer noopener" target="_blank" >
                                            <div className="header time">
                                                <div className="date-time">
                                                    <div className="date">
                                                        <div className="month">
                                                            Apr
                                                        </div>
                                                        <div className="day">
                                                            29
                                                        </div>
                                                        <div className="dow">
                                                            Thu
                                                        </div>
                                                    </div>
                                                    <div className="time">
                                                        4:00 pm
                                                    </div>
                                                </div>
                                                <h5 className="title">
                                                    CI/CD Pipelines with Jenkins and OpenShift
                                                </h5>
                                                Webinar by Red Hat
                                            </div>
                                            <p className="teaser">
                                                Transforming Test-Driven Workflows Into CI/CD Pipelines With Jenkins. By using Jenkins and Red Hat® OpenShift®, you can build CI/CD pipelines to automate your development process and improve time-to-market of your application
                                            </p>
                                            <div className="more"></div>
                                            <p></p>
                                        </a>
                                    </li>
                                    <li className="post event">
                                        <a className="body" href="https://www.meetup.com/CD-Foundation-Online/events/277407348/" rel="noreferrer noopener" target="_blank">
                                            <div className="header time">
                                                <div className="date-time">
                                                    <div className="date">
                                                        <div className="month">
                                                            May
                                                        </div>
                                                        <div className="day">
                                                            12
                                                        </div>
                                                        <div className="dow">
                                                            Wed
                                                        </div>
                                                    </div>
                                                    <div className="time">
                                                        12:00 pm
                                                    </div>
                                                </div>
                                                <h5 className="title">
                                                    Jenkins Templating Engine
                                                </h5>
                                                CDF Online Meetup
                                            </div>
                                            <p className="teaser">
                                                Steven Terrana will talk about using the Jenkins Templating Engine for Pipeline Modeling.
                                            </p>
                                            <div className="more"></div>
                                            <p></p>
                                        </a>
                                    </li>
                                    <li className="post event">
                                        <a className="body" href="https://events.linuxfoundation.org/cdcon/" rel="noreferrer noopener" target="_blank">
                                            <div className="header time">
                                                <div className="date-time">
                                                    <div className="date">
                                                        <div className="month">
                                                            Jun
                                                        </div>
                                                        <div className="day">
                                                            22
                                                        </div>
                                                        -
                                                        <div className="month">
                                                            Jun
                                                        </div>
                                                        <div className="day">
                                                            24
                                                        </div>
                                                        <div className="dow">
                                                            Tue
                                                        </div>
                                                    </div>
                                                    <div className="time">
                                                        9:00 am
                                                    </div>
                                                </div>
                                                <h5 className="title">
                                                    cdCon
                                                </h5>
                                                Online
                                            </div>
                                            <p className="teaser">
                                                Jenkins will be represented at cdCon organized by the Continuous Delivery Foundation. We will have multiple talks and a Birds of Feather session there.
                                            </p>
                                            <div className="more"></div>
                                            <p></p>
                                        </a>
                                    </li>
                                    <li className="post event">
                                        <a className="body" href="https://www.jenkins.io/events/contributor-summit" rel="noreferrer noopener" target="_blank">
                                            <div className="header time">
                                                <div className="date-time">
                                                    <div className="date">
                                                        <div className="month">
                                                            Jun
                                                        </div>
                                                        <div className="day">
                                                            25
                                                        </div>
                                                        <div className="dow">
                                                            Fri
                                                        </div>
                                                    </div>
                                                    <div className="time">
                                                        9:00 am
                                                    </div>
                                                </div>
                                                <h5 className="title">
                                                    Jenkins Contributor Summit
                                                </h5>
                                                    Online
                                            </div>
                                            <p className="teaser">
                                                The Jenkins Contributor Summit brings together current and future contributors to the Jenkins project. The summit brings together community members to learn, meet, and help shape the future of Jenkins.
                                            </p>
                                            <div className="more"></div>
                                            <p></p>
                                        </a>
                                    </li>
                                    <li className="post event">
                                        <a className="body" href="https://www.cloudbees.com/devops-world" rel="noreferrer noopener" target="_blank">
                                            <div className="header time">
                                                <div className="date-time">
                                                    <div className="date">
                                                        <div className="month">
                                                            Sep
                                                        </div>
                                                        <div className="day">
                                                            29
                                                        </div>
                                                        -
                                                        <div className="month">
                                                            Sep
                                                        </div>
                                                        <div className="day">
                                                            30
                                                        </div>
                                                        <div className="dow">
                                                            Wed
                                                        </div>
                                                    </div>
                                                    <div className="time">
                                                        9:00 am
                                                    </div>
                                                </div>
                                                <h5 className="title">
                                                    evOps World
                                                </h5>
                                                Online
                                            </div>
                                            <p className="teaser">
                                                Jenkins will be represented at the DevOps World conference. There will be community and Continuous Delivery Foundation tracks, and many talks from Jenkins practitioners.
                                            </p>
                                            <div className="more"></div>
                                            <p></p>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}